// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"0":"84bccac8","179":"ce946bad","274":"b7e86cd2","637":"a33d0b46","673":"ce55fbd1","787":"99266118"}[chunkId] + ".css";
};